import "./CTA.css";

const CTA = () => {
  const scrollToContact = () => {
    const contact = document.getElementById("contact");
    contact?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="cta">
      <div className="cta-box">
        <h2>Have an Idea? Let’s Build It Together.</h2>
        <p>
          From concept to launch, we bring your digital vision to life.
        </p>

        <button onClick={scrollToContact}>
          Schedule Consultation
        </button>
      </div>
    </section>
  );
};

export default CTA;
